import { atom } from 'jotai';

export const laborValues = atom({
    asSoldLabor: 0,
    dayZeroBudgetLabor: 0,
    JTDLabor: 0,
    laborCommitments: 0,
    laborETC: 0,
    laborEAC: 0
});

export const equipmentValues = atom({
    asSoldEquipment: 0,
    dayZeroBudgetEquipment: 0,
    JTDEquipment: 0,
    equipmentCommitments: 0,
    equipmentETC: 0,
    equipmentEAC: 0
});

export const dayZeroBudgetLabor = atom(0);

export const JTDLabor = atom(0);

export const laborCommitted = atom(0);

export const coLabor = atom(0);

export const coEquipment = atom(0);

export const coMaterial = atom(0);

export const coSubcontractors = atom(0);

export const coOther = atom(0);

export const coTotal = atom(0);

export const coContract = atom(0);

export const subcontractorCommitted = atom(0);

export const subcontractors = atom([]);

export const rentalsCommited = atom(0);

export const rentals = atom([]);

export const materialsCommited = atom(0);

export const materialsRows = atom([]);

export const totalCORevenue = atom(0);